import React from 'react';
import { clamp } from 'lodash';
import styles from './ui-wizard-flow-progress-bar.scss';
import classNames from 'classnames';

export interface UIWizardFlowProgressBarProps {
  value: number;
  displaySubNav?: boolean;
}

export const UIWizardFlowProgressBar = ({ value = 0, displaySubNav = false }: UIWizardFlowProgressBarProps) => {
  const safeValue = clamp(value, 0, 100);

  return (
    <div
      className={classNames(styles.container, {
        [styles.stickyContent]: displaySubNav
      })}
      data-testid="UIWizardFlowProgressBar"
    >
      <div className={styles.inner} style={{ width: `${safeValue}%` }} />
    </div>
  );
};
